import React from "react";
import { Row, Col, Card, Skeleton, Icons } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";

interface KpiCardsProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const KpiCard: React.FC<{
  icon: React.ReactNode;
  label: string;
  value: number | string;
  color?: string;
}> = ({ icon, label, value, color = "#459cd3" }) => (
  <Card
    style={{ borderLeft: `4px solid ${color}`, height: "100%" }}
    bodyStyle={{
      display: "flex",
      alignItems: "center",
      gap: 16,
      padding: "20px 24px",
    }}
  >
    <div style={{ fontSize: 32, color }}>{icon}</div>
    <div>
      <div style={{ fontSize: 24, fontWeight: 700, color: "#1a1a1a" }}>
        {typeof value === "number" ? value.toLocaleString("tr-TR") : value}
      </div>
      <div style={{ fontSize: 14, color: "#8c8c8c" }}>{label}</div>
    </div>
  </Card>
);

export const KpiCards: React.FC<KpiCardsProps> = ({ dateRange, shopCode }) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/overview`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const d: any = response?.data || {};

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} xl={6}>
        <KpiCard
          icon={<Icons.ThunderboltOutlined />}
          label="Toplam Etkileşim"
          value={parseInt(d.totalEvents, 10) || 0}
        />
      </Col>
      <Col xs={24} sm={12} xl={6}>
        <KpiCard
          icon={<Icons.ShoppingOutlined />}
          label="Ürün Tıklama"
          value={parseInt(d.productClicks, 10) || 0}
          color="#FFC900"
        />
      </Col>
      <Col xs={24} sm={12} xl={6}>
        <KpiCard
          icon={<Icons.WifiOutlined />}
          label="5G Modal Açılma"
          value={parseInt(d.fiveGModalOpens, 10) || 0}
          color="#448ab7"
        />
      </Col>
      <Col xs={24} sm={12} xl={6}>
        <KpiCard
          icon={<Icons.ShopOutlined />}
          label="Aktif Mağaza Sayısı"
          value={parseInt(d.uniqueShops, 10) || 0}
          color="#18619c"
        />
      </Col>
    </Row>
  );
};
